// extracted by mini-css-extract-plugin
module.exports = {"actions":"adminWork-actions_actions__2B3oW"};